<template>
  <v-dialog
    v-model="showingFullImage"
    fullscreen
  >
    <v-container
      :style="style"
      fluid
      v-touch="{
        left: () => nextImg(),
        right: () => prevImg()
      }"
    >
      <v-row
        class="fill-height align-center justify-center"
      >
        <v-col
          cols="1"
          class="pa-4 text-right"
        >
          <v-btn
            class="csr-btn-color"
            style="z-index:1;"
            fab
            dark
            text
            small
            @click="prevImg"
          >
            <v-icon large>chevron_left</v-icon>
          </v-btn>
        </v-col>
        <v-col
          cols="7"
          :style="fullContainerStyle"
        >
          <!-- preload images -->
          <img
            v-if="preloadImg1"
            :src="fullPath + images[preloadImg1].image"
            style="width: 30px;position: absolute; left: 10000px"
          />
          <img
            v-if="preloadImg2"
            :src="fullPath + images[preloadImg2].image"
            style="width: 30px;position: absolute; left: 10000px"
          />
          <!-- /preload images -->

          <div class="full-container">
            <div :class="'full-container-img-outer'">
              <img
                :src="fullPath + fullImage1.image"
                :class="' ' + (
                  image1Transparent ? ' img-transparent' : ''
                )"
              />
              <img
                :src="fullPath + fullImage2.image"
                :class="' ' + (
                  image2Transparent ? ' img-transparent' : ''
                )"
              />
              <div class="img-name">
                {{ imageLabel(!image1Transparent ? fullImage1 : fullImage2) }}
              </div>
            </div>
            <div :class="'full-container-img-outer' + (
              image2Transparent ? ' img-transparent' : ''
              )"
            >
            </div>
          </div>
        </v-col>

        <v-col
          cols="1"
          class="pa-4 text-left"
        >
          <v-btn
            style="z-index:1;"
            class="csr-btn-color"
            fab
            dark
            text
            small
            @click="nextImg"
          >
            <v-icon large>chevron_right</v-icon>
          </v-btn>
        </v-col>

        <v-col
          cols="3"
          class="pa-5"
        >
          <v-row
            v-if="!mobile"
            class="mt-3 mb-3 text-center"
          >
            <v-col cols="12" class="pb-5">
              <v-btn
                class="csr-btn-color"
                style="z-index:1;"
                fab
                text
                dark
                small
                @click="closeFull"
              >
                <v-icon large>close</v-icon>
              </v-btn>
            </v-col>

            <v-col cols="6" class="py-3" style="width: 100%;">
              <img
                :src="fullPath + previewSideImage2.image"
                style="width:calc(100% - 20px); margin: 10px; border-radius: 8px;"
                @click="nextImg();"
              />
            </v-col>

            <v-col cols="6" class="pt-3" style="width: 100%;">
              <img
                :src="fullPath + previewSideImage3.image"
                style="width:calc(100% - 20px); margin: 10px; border-radius: 8px;"
                @click="nextImg();nextImg();"
              />
            </v-col>

            <v-col cols="12" class="pt-5 text-center">
              <span style="font-size: 18px;">{{ selectedImageIndex + 1 }} / {{ images.length }}
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<script>
import methods from '../../methods/methods'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
import sharedComputed from '@/methods/sharedComputed'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ObjectImagesFull',

  data: () => {
    return {

    }
  },

  props: {
    images: {
      type: Array,
      default: () => {
        return []
      }
    },
    rooms: {
      type: Array,
      default: () => {
        return []
      }
    },
    compact: {
      type: Boolean,
      default: false
    },
    imgFolder: {
      type: String,
      default: null
    }
  },

  computed: {
    ...sharedComputed,
    ...mapFields(Object.keys(state)),

    fullPath () {
      return this.s3url + this.imgFolder + '/'
    },

    fullContainerStyle () {
      return {
        height: (this.windowHeight * 1) + 'px'
      }
    },

    style () {
      return {
        'z-index': 1500,
        height: this.windowHeight + 'px',
        width: this.windowWidth + 'px',
        position: 'fixed',
        left: 0,
        top: 0,
        'background-color': 'rgba(255, 255, 255, 1)'
      }
    }
  },

  created () {
    window.addEventListener('keyup', this.keyupOnImageView)
  },

  destroyed () {
    window.removeEventListener('keyup', this.keyupOnImageView)
  },

  methods: {
    ...methods,

    imageLabel (image) {
      return ''
      // return this.$store.state.objectRoomTypesById[this.rooms[0].type]['typeName_' + this.lang]
    },

    keyupOnImageView (e) {
      if (e.code === 'ArrowLeft') {
        this.prevImg()
      } else if (e.code === 'ArrowRight') {
        this.nextImg()
      }
    }
  }
}
</script>

<style>
.img-name {
    margin: auto;
    position: absolute;
    height: auto;
    width: 100%;
    top: calc(50% + 290px);
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 10;
    font-size: 18px;
}
</style>
